var styleDataHash = "26e11e81";
const injectCss = () => {
  var css = `.glob_fontElementMap,.hY3Cg{font-family:var(--ricos-font-family,unset)}.aF6gP{display:block;width:100%}[dir] .aF6gP{padding-top:8px}.UO0I7,.qjdhc{height:277px;overflow:auto}[dir] .UO0I7,[dir] .qjdhc{padding-top:8px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.UO0I7,.qjdhc{height:calc(100vh - 132px)}}}@container (width < 640px){.UO0I7,.qjdhc{height:calc(100vh - 132px)}}.i2wux{display:grid;grid-auto-rows:87px;grid-template-columns:calc(50% - 4px) calc(50% - 4px);grid-gap:8px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.i2wux{grid-auto-rows:99px}}}@container (width < 640px){.i2wux{grid-auto-rows:99px}}.BthTM{height:277px}[dir] ._4rPGC{padding-bottom:6px}[dir=ltr] ._4rPGC{padding-right:18px}[dir=rtl] ._4rPGC{padding-left:18px}.Ssg0x{width:4px}[dir] .Ssg0x{background:#000;border-radius:4px}[dir=ltr] .Ssg0x{margin-left:-2px}[dir=rtl] .Ssg0x{margin-right:-2px}[dir=ltr] .Sw59t{float:right;text-align:right}[dir=rtl] .Sw59t{float:left;text-align:left}.WzhH6{height:100%;overflow:hidden;width:100%}[dir] .WzhH6{cursor:pointer}[dir] ._98U-k{margin-top:20px;text-align:center}.oy4pb{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.hSt4E{align-content:center;display:grid;font-size:14px;height:100%;letter-spacing:1px}[dir] .hSt4E{text-align:center}.UO0I7{align-items:center;display:flex;justify-content:center;max-width:207px}.ZVNHP{color:var(--ricos-settings-text-color,#000);font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:14px;font-weight:300;line-height:1.57}[dir] .ZVNHP{padding:0 20px;text-align:center}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_selecter_default = {
  "fontElementMap": "hY3Cg",
  "giphy_selector_container": "aF6gP",
  "giphy_selector_infinite_scroll_container": "qjdhc",
  "giphySelectorErrorContainer": "UO0I7",
  "giphy_selector_infinite_scroll": "i2wux",
  "giphy_selector_customize_scrollbar_container": "BthTM",
  "giphy_selector_headerInfiniteScroll": "_4rPGC",
  "giphy_selector_scrollbarThumb": "Ssg0x",
  "giphy_selector_powerdByGiphy": "Sw59t",
  "giphy_selector_gif_img_container": "WzhH6",
  "giphy_selector_spinner_more": "_98U-k",
  "giphy_selector_spinner_empty_modal": "oy4pb",
  "giphy_empty_state": "hSt4E",
  "giphySelectorErrorMessage": "ZVNHP"
};
export {
  giphy_selecter_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selecter-scss.js.map
